import { standardNativeParams, isMobileOrPad } from '../utils/utils';
export const WEBID_KEY = 's_v_web_id';
export const TEA_EVENT_PREFIX = 'h5_';
export const JSB_TIMEOUT = 5000;
export const SDK_VERSION = process.env.REACT_APP_SDK_VERSION;
export const USE_TYPE_ENV = process.env.USE_TYPE_ENV;
// 在web和h5初始化sdk时，会设置window.captchaHost域名
export const SERVER_URL = window.captchaHost || process.env.REACT_APP_SERVER_URL || '';
export const PATH = {
  slide: '/slide',
  '3d': '/3d',
  text: '/text',
};

export const URL = {
  international: 'captcha/i18n',
  get: 'captcha/get',
  verify: 'captcha/verifyV2',
  domains: 'captcha/domains',
  feedback: 'captcha/feedback',
  schedulingDomain: 'captcha/region',
  sendCode: '/notify/sms/web/send_code',
  validateCode: '/notify/sms/check_code',
};
export const SERVER_MAP = process.env.SERVER_MAP || {};
// app端 需要获取H5 URL上的参数，透传给后端captcha/get和captcha/verify接口
export const searchObj = standardNativeParams(window.location.search);
export const isNative = searchObj.os_type === '0' || searchObj.os_type === '1';
export const isMobile = isMobileOrPad();
export const useDialogSizeV2 = searchObj.use_dialog_size_v2;

export const envRegion = (() => {
  let env_region = 'va';
  switch (process.env.REGION_ENV) {
    case 'boe':
    case 'cn':
      env_region = 'cn';
      break;
    case 'sg':
      env_region = 'sg';
      break;
    case 'va':
      env_region = 'va';
      break;
    case 'in':
      env_region = 'in';
      break;
    case 'ttp':
      env_region = 'ttp';
      break;
    case 'ttp2':
      env_region = 'ttp2';
      break;
  }
  return env_region;
})();

export const scale = isMobile ? 1 : 340 / 276;

export const SECURE_SCRIPT_TIMEOUT = 700;

export const SECURE_URL = [URL.get, URL.verify];

export const HORIZON_SCALE = 0.86;

export const HORIZON = 1;

export const VERTICAL = 0;

export enum VerifyType {
  captcha = 1,
  secondVerify = 2,
}
